
const queryTagHeader = 'X-qt';

function getQueryTag({ liveMode }) {
  return { [queryTagHeader] : liveMode ? 'realtime' : 'historic' };
}

export default getQueryTag;
